import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Style/Style.css";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BACKEND_URL } from "./services/helper";

const Contact = ({setProgress}) => {
  let navigate = useNavigate();
  const [userdata, setUserData] = useState({
    fname: "",
    email: "",
    phone: "",
    whnumber: "",
    expert: "",
    problem: "",
  });

  const userContact = async () => {
    try {
      let token = localStorage.getItem("userdatatoken");
     
      axios({
        url: `${BACKEND_URL}/contact`,
        method: "GET",
        headers:{
          "Content-Type": "application/json",
            "Authorization": token
        }
      })
      .then((res)=>{
        setUserData({
          ...userdata,
          fname: res.data.fname,
          email: res.data.email,
          phone: res.data.phone,
        });
      })
      .catch((err,res)=>{
        if (err) {
          navigate("/login");
        }
        // console.log("yhi pe error hai", err);
      })
      
    } catch (err) {
      // console.log("there is an error", err);
    }
  };

  useEffect(() => {
    userContact();
  }, []);

  const setdata = (e) => {
    // console.log(e.target.value);
    const { name, value } = e.target;
    setUserData({ ...userdata, [name]: value });
  };
  // send data to backend------------------------------------

  const addinpdata = async (e) => {
    e.preventDefault();
    // console.log(userdata);
    const { fname, email, phone, whnumber, expert, problem } = userdata;
    let token = localStorage.getItem("userdatatoken");
    if (expert === "") {
      toast.warning("expert name is required!", {
        position: "top-center",
      });
    }else if (fname === "") {
      toast.warning("Full name is required!", {
        position: "top-center",
      });
    }else if (email === "") {
      toast.warning("email is required!", {
        position: "top-center",
      });
    }else if (phone === "") {
      toast.warning("phone number is required!", {
        position: "top-center",
      });
    }else if (whnumber === "") {
      toast.warning("whatapp number is required!", {
        position: "top-center",
      });
    }else if (problem === "") {
      toast.error("problem is required!", {
        position: "top-center",
      });
    } else {
      setProgress(20)
      setProgress(40)
      setProgress(60)
      axios({
        url: `${BACKEND_URL}/message`,
        method: "POST",
        headers:{
          "Content-Type": "application/json",
          "Authorization": token
        },
        data: userdata,
      })
      .then((res)=>{
        setProgress(80)
        // console.log(res);
        if (res.status === 422 || !res.data) {
          setProgress(100)
          toast.error("Already Submitted!", {
            position: "top-center",
          });
        } else {
          setProgress(100)
          toast.success("Details Submitted! We will get to you soon by mail", {
            position: "top-center",
          });
          setUserData({
            ...userdata,
            whnumber: "",
            expert: "",
            problem: "",
          });
        }
      })
      .catch((err)=>{
        // console.log("yhi pe error hai", err);
        
      })
      
    }
  };

  return (
    <div>
      <section className="contact" id="contact">
        <div className="fo">
          <h2 className="heading">Contact <span>Us!</span></h2>
          <form method="POST">
            <div className="input-box">
              <input type="name" onChange={setdata} value={userdata.fname} name="fname" placeholder="Enter Full Name"/>
              <input type="email" onChange={setdata} value={userdata.email} name="email" placeholder="Enter Email Address" />
            </div>
            <div className="input-box">
              <input type="number" onChange={setdata} value={userdata.phone} name="phone" placeholder="Enter Mobile Number" />
              <input type="number" onChange={setdata} value={userdata.whnumber} name="whnumber" placeholder="Enter Whatapp Number if Avilable" />
            </div>
            <div className="input-box">
              <input type="text" onChange={setdata} value={userdata.expert} name="expert" placeholder=" Enter Expert Name" />
              <input type="text" onChange={setdata} value={userdata.problem} name="problem" placeholder="Enter Our Services you want" />
            </div>
            <input type="submit" onClick={addinpdata} value="Send Message" className="btn2"/>
          </form>
        </div>
        <ToastContainer />
      </section>
    </div>
  );
};

export default Contact;
